import {
  AddPreferencePermissionResponse,
  DeletePreferencePermissionResponse,
  DeletePreferenceResponse,
  Preference,
  PreferenceResponse,
  PreferenceResponseStatus,
} from './Types';

export const PREFERENCE_SAVE_NAME_ERROR_MESSAGE = 'Please provide a unique name to proceed.';
export const PREFERENCE_SAVE_ERROR_MESSAGE = 'There has been an error while saving preference';
export const INVALID_PREFERENCE_ID_MESSAGE = 'Invalid preference id.';
export const DELETE_SUCESS_MESSAGE = 'preference was deleted.';
export const PREFERENCE_ID_NOT_FOUND_MESSAGE = 'No preference with this id was found.';
export const PREFERENCE_DELETE_ERROR_MESSAGE = 'Preference has not been removed due to error.';
export const DELETE_PREFERENCE_PERMISSION_SUCCESS_MESSAGE = 'Preference permission was deleted.';
export const PREFERENCE_PERMISSION_DELETE_ERROR_MESSAGE = 'Preference permission has not been removed due to error.';
export const ADD_PREFERENCE_PERMISSION_SUCCESS_MESSAGE = 'preference permission was added.';
export const PREFERENCE_PERMISSION_ADD_ERROR_MESSAGE = 'Preference permission has not been added due to error.';

/**
 * @return PreferenceResponse/DeletePreferenceResponse
 *
 * @remarks
 * functions to create preference response that contains meaningful message and status
 * **/

export const createPreferencesSuccessfullySavedResponse = <T>(
  namespace: string,
  preference: Preference<T>,
): PreferenceResponse<T> => {
  return {
    message: `Preference for ${namespace} were saved`,
    status: PreferenceResponseStatus.SUCCESS,
    values: preference,
  };
};

export const createPreferencesNameNotUniqueResponse = <T>(): PreferenceResponse<T> => {
  return {
    message: PREFERENCE_SAVE_NAME_ERROR_MESSAGE,
    status: PreferenceResponseStatus.VALIDATION_ERROR,
  };
};

export const createPreferencesCouldNotBeSavedResponse = <T>(preferenceKey: string): PreferenceResponse<T> => {
  return {
    message: `${PREFERENCE_SAVE_ERROR_MESSAGE} ${preferenceKey}`,
    status: PreferenceResponseStatus.ERROR,
  };
};

export const createInvalidIdResponse = <T>(id: string): PreferenceResponse<T> => {
  return {
    message: `${INVALID_PREFERENCE_ID_MESSAGE} ${id}`,
    status: PreferenceResponseStatus.ERROR,
  };
};

export const createPreferencesDeleteSuccessfullyResponse = (preferenceKey: string): DeletePreferenceResponse => {
  return {
    message: `${preferenceKey} ${DELETE_SUCESS_MESSAGE}`,
    status: PreferenceResponseStatus.SUCCESS,
  };
};

export const createDeletePreferencesPermissionSuccessfullyResponse = (
  preferenceKey: string,
): DeletePreferencePermissionResponse => {
  return {
    message: `${preferenceKey} ${DELETE_PREFERENCE_PERMISSION_SUCCESS_MESSAGE}`,
    status: PreferenceResponseStatus.SUCCESS,
  };
};

export const createAddPreferencesPermissionSuccessfullyResponse = (
  preferenceKey: string,
): AddPreferencePermissionResponse => {
  return {
    message: `${preferenceKey} ${ADD_PREFERENCE_PERMISSION_SUCCESS_MESSAGE}`,
    status: PreferenceResponseStatus.SUCCESS,
  };
};

export const createPreferencesIdNotFoundResponse = (
  id: string,
): DeletePreferenceResponse | DeletePreferencePermissionResponse | AddPreferencePermissionResponse => {
  return {
    message: `${PREFERENCE_ID_NOT_FOUND_MESSAGE} (${id})`,
    status: PreferenceResponseStatus.VALIDATION_ERROR,
  };
};

export const createPreferencesCouldNotBeDeletedResponse = (): DeletePreferenceResponse => {
  return {
    message: PREFERENCE_DELETE_ERROR_MESSAGE,
    status: PreferenceResponseStatus.ERROR,
  };
};

export const createPreferencesPermissionCouldNotBeDeletedResponse = (): DeletePreferencePermissionResponse => {
  return {
    message: PREFERENCE_PERMISSION_DELETE_ERROR_MESSAGE,
    status: PreferenceResponseStatus.ERROR,
  };
};

export const createPreferencesPermissionCouldNotBeAddedResponse = (): AddPreferencePermissionResponse => {
  return {
    message: PREFERENCE_PERMISSION_ADD_ERROR_MESSAGE,
    status: PreferenceResponseStatus.ERROR,
  };
};
